var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 0C3.67909 0 3.5 0.188511 3.5 0.421052V16.8421H2.4C2.17909 16.8421 2 17.0306 2 17.2632V19.5789C2 19.8115 2.17909 20 2.4 20H17.6C17.8209 20 18 19.8115 18 19.5789V17.2632C18 17.0306 17.8209 16.8421 17.6 16.8421H16.5V5.26316H17.5V12.2105C17.5 13.0244 18.1268 13.6842 18.9 13.6842H20V11.5789H19.5V4.63158C19.5 3.81769 18.8732 3.15789 18.1 3.15789H16.5V0.421053C16.5 0.188512 16.3209 0 16.1 0H3.9ZM14.5 2.10526V8.42105H5.5V2.10526H14.5Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.638fdcc800d8625190325b0897f59fcb.svg";
export { ForwardRef as ReactComponent };